import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const merchandiseRackByCustomerTodo = createAsyncThunk('merchandiseRackByCustomer', async ({ id, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `merchandise-rack-by-cust`,
            params: {
                'customerId': id,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const merchandiseRackByCustomerSlice = createSlice({
    name: 'merchandiseRackByCustomer',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(merchandiseRackByCustomerTodo.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(merchandiseRackByCustomerTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default merchandiseRackByCustomerSlice.reducer; 